import { Injectable } from '@angular/core';
import { Role } from '@perval/shared';

@Injectable({
  providedIn: 'root',
})
export class AccessService {
  constructor() {}

  hasAccess(requiredRoles: Role[], userRoles: Role[]) {
    if (!requiredRoles?.length) {
      return true;
    }
    return requiredRoles.some((r) => userRoles.includes(r));
  }
}
